import { render, staticRenderFns } from "./ClaimFormPage.vue?vue&type=template&id=380a164a&scoped=true&"
import script from "./ClaimFormPage.vue?vue&type=script&lang=js&"
export * from "./ClaimFormPage.vue?vue&type=script&lang=js&"
import style0 from "./ClaimFormPage.vue?vue&type=style&index=0&id=380a164a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a164a",
  null
  
)

export default component.exports